import axios from 'axios'
const getCoordinatorsLists = () => {
  //const proxy = location.host.includes('local') || location.host.includes('upress') || location.host.includes('vangus') ? 'https://cors-anywhere.herokuapp.com/' : ''//
  const proxy = ''// 'https://cors-anywhere.herokuapp.com/'
  const url = 'http://api.bat-ami.org.il/Api/'
  const lists = document.querySelectorAll('.coordinators-list')


  if (!lists || lists.length == 0) return null

  lists.forEach(list => {
    const loadingElement = list.parentElement.querySelector('.loading')
    console.log(list)
    loadingElement.classList.add('loading--active')

    const queryBy = list.dataset.query
    if (!queryBy) {
      console.error('not enough informaition for dispalying coordinators list')
      return null
    }
    const params = {}
    loadingElement.classList.add('loading--active')

    axios.get(proxy + url + queryBy, {
      params,
    })
      .then(res => {
        loadingElement.classList.remove('loading--active')
        // if (res.data.length > 100) {
        //   // throw new Error(`${res.data.length} coordinators is too much`)
        // }
        const html = `<table class="wp-block-table is-style-stripes">
        <tr><td><strong>מוסד</strong></td><td><strong>רכזת</strong></td><td><strong>טלפון</strong></td></tr>`
          + res.data.map(coordinator => `
            <tr class="coordinator1">
              <td class="coordinator__inst1">${coordinator.Name}</td>
              <td class="coordinator__name1">${coordinator.CooName}</td>
              <td class="coordinator__phone1">${coordinator.CooPhone}</td>
            </tr>
            `).join('')
          + `</table>`

        list.insertAdjacentHTML('afterbegin', html)
        return res
      })
      .catch(err => {
        loadingElement.classList.remove('loading--active')
        console.log(err)
      })

  })
}

export default getCoordinatorsLists